import classNames from 'classnames'
import dynamic from 'next/dynamic'

import { vsmBgCss } from './styles.css'
import { VsmProps } from './types'

const ReactVsmProxy = dynamic(() => import('./vsm-proxies').then(({ ReactVsmProxy }) => ReactVsmProxy), { ssr: false })

export function Vsm({ className, style, ...props }: VsmProps) {
  return (
    <div
      className={classNames(vsmBgCss, className)}
      style={style}
    >
      <ReactVsmProxy {...props} />
    </div>
  )
}
